/* eslint-disable */
import { ChangeEvent, FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Hidden,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
} from '@material-ui/core';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import MenuIcon from '../icons/Menu';
import LogoNavBar from './LogoNavBar';
import { useStyles } from './style';
import useGeneral from 'src/hooks/useGeneral';
import { createBrowserHistory } from 'history';

interface NavbarLandingProps {
  onSidebarMobileOpen?: () => void;
}

interface StyledTabsProps {
  children: any;
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#003e75',
    '& > span': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#635ee7',
    },
  },
})((props: StyledTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
));

interface StyledTabProps {
  label: string;
}

const StyledTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 72,
      textTransform: 'none',
      color: '#ffffff',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(15),
      marginRight: theme.spacing(1),
      '&:focus': {
        opacity: 1,
        color: '#000000',
        backgroundColor: '#ffffff',
      },
    },
    selected: {
      '&$selected': {
        opacity: 1,
        color: '#013E75',
        fontWeight: 700,
        backgroundColor: '#ffffff',
      },
    },
  })
)((props: StyledTabProps) => <Tab disableRipple {...props} />);

const NavbarLanding: FC<NavbarLandingProps> = (props) => {
  const { setLanding } = useGeneral();
  const classes = useStyles();
  const { onSidebarMobileOpen } = props;
  const [value, setValue] = useState(0);
  let history = createBrowserHistory();
  const navigate = useNavigate();

  const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
    if (
      history.location.pathname === '/proveedor' ||
      history.location.pathname === `/proveedor/`
    ) {
      setValue(0);
      navigate('/');
    } else {
      setValue(1);
      navigate('/proveedor/');
    }
  };

  useEffect(() => {
    if (
      history.location.pathname === `/proveedor/` ||
      history.location.pathname === '/proveedor' ||
      history.location.pathname === '/proveedor/#contactProveedor' ||
      history.location.pathname === '/proveedor/#techProveedor' ||
      history.location.pathname === '/proveedor/#benefitProveedor' ||
      history.location.pathname === '/proveedor/#videoProveedor' ||
      history.location.pathname === '/proveedor/#whatProveedor'
    ) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [history.location.pathname]);

  return (
    <>
      <Box
        sx={{
          zIndex: 999,
          height: { md: '95px' },
          width: '100%',
          backgroundColor: '#ffffff',
          marginTop: '-64px',
          position: 'fixed',
        }}
      >
        <Box
          sx={{
            height: '40px',
            backgroundColor: '#013E75',
          }}
        >
          <Container maxWidth="lg">
            <StyledTabs value={value} onChange={handleChange}>
              <StyledTab label="Empresa" />
            </StyledTabs>
          </Container>
        </Box>
      </Box>
      <AppBar className={classes.appBar}>
        <Container maxWidth="lg">
          <Toolbar sx={{ minHeight: 64 }}>
            <Hidden mdUp>
              <IconButton
                onClick={onSidebarMobileOpen}
                sx={{ color: '#001930' }}
              >
                <MenuIcon fontSize="large" />
              </IconButton>
            </Hidden>
            <RouterLink to="/">
              <LogoNavBar
                sx={{
                  textAlign: 'left',
                  height: 40,
                  width: 210,
                }}
              />
            </RouterLink>
            {/* <Box sx={{ flexGrow: 1 }} /> */}
            <Hidden mdDown>
              {value === 1 && (
                <Box className={classes.boxContainerProveedor}>
                  <Button
                    href="/proveedor/#whatProveedor"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Qué hacemos
                  </Button>
                  <Button
                    href="/proveedor/#videoProveedor"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Qué nos diferencia
                  </Button>
                  <Button
                    href="/proveedor/#benefitProveedor"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Beneficios
                  </Button>
                  <Button
                    href="/proveedor/#techProveedor"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Tecnologías
                  </Button>
                  <Button
                    href="/proveedor/#contactProveedor"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Contacto
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Button
                    sx={{
                      backgroundColor: '#FCBE00',
                      textAlign: 'center',
                      minWidth: '117px',
                      ml: 1,
                      '&:hover': {
                        backgroundColor: '#fbd972',
                      },
                    }}
                    component="a"
                    href="/authentication/login"
                    variant="contained"
                  >
                    Iniciar sesión
                  </Button>
                </Box>
              )}
              {value === 0 && (
                <Box className={classes.boxContainer}>
                  <Button
                    href="/#what"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Qué hacemos
                  </Button>
                  <Button
                    href="/#video"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Así funcionamos
                  </Button>
                  <Button
                    href="/#how"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Cómo lo hacemos
                  </Button>
                  <Button
                    href="/#advantage"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Ventajas competitivas
                  </Button>
                  <Button
                    href="/#benefit"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Beneficios
                  </Button>
                  <Button
                    href="/#tech"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Tecnologías
                  </Button>
                  <Button
                    href="/#contact"
                    component="a"
                    sx={{
                      textAlign: 'center',
                      ml: 1,
                      color: '#5d6b83',
                      fontWeight: 400,
                    }}
                  >
                    Contacto
                  </Button>
                  <Divider orientation="vertical" flexItem />
                  <Button
                    sx={{
                      backgroundColor: '#FCBE00',
                      textAlign: 'center',
                      minWidth: '117px',
                      ml: 1,
                      '&:hover': {
                        backgroundColor: '#fbd972',
                      },
                    }}
                    component="a"
                    href="/authentication/login"
                    variant="contained"
                  >
                    Iniciar sesión
                  </Button>
                </Box>
              )}
            </Hidden>
          </Toolbar>
          <Divider />
        </Container>
      </AppBar>
    </>
  );
};

NavbarLanding.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default NavbarLanding;
